const flattenSegmentedArrayValues = (
  segmentedValuesList,
) => (
  segmentedValuesList
  .flat()
)

export default flattenSegmentedArrayValues
